export const createLogger = (prefix: string) => ({
  log: function(...args: any) {
    console.log(`%c${prefix}`, 'color:red', ...args);
  },
});
